
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'multiline_chart': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 13.49',
    data: '<path pid="0" d="M20 1.92L18.59.51l-2.85 3.21A10.764 10.764 0 0 0 7.61 0 11.459 11.459 0 0 0 0 3l1.42 1.42A9.388 9.388 0 0 1 7.61 2a8.789 8.789 0 0 1 6.77 3.24L11.5 8.48l-4-4L0 11.99l1.5 1.5 6-6.01 4 4 4.05-4.55a12.272 12.272 0 0 1 1.44 4.55H19a14.143 14.143 0 0 0-2.04-6.14L20 1.92z" _fill="#d9d9d9" fill-rule="evenodd"/>'
  }
})
